<template>
  <div class="footer">
    <div class="copyright">
      <a-icon type="copyright"/>
      2023 <span>{{ $t('custom.copyright.copyright') }}</span>
      <a href="https://www.i-search.com.cn/" target="_blank">{{ $t('custom.copyright.links') }}</a> -<a href="http://www.beian.miit.gov.cn/" target="_blank">沪ICP备12049238号</a>
      <!-- 公安备案 -->
      <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011202011869">沪公网安备 31011202011869号</a>
      <img src="./img/gov.png"/>
      &nbsp;
      <span>增值电信业务经营许可证：沪B2-20190908</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LayoutFooter',
  data () {
    return {
    }
  }
}
</script>

<style lang="less" scoped>
  .footer {
    padding: 0 16px;
    margin: 12px 0;
    text-align: center;
    .copyright {
      color: #999;
      font-size: 12px;
      a{
        margin-left: 6px;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
</style>
